/**
 * @Description 跟进状态
 */

import { FC, } from 'react';

import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';

const FormFollowingStatus:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
  isEdit?: boolean; // 是否新增、编辑状态
  disabled?: boolean;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
  isEdit,
  disabled,
}) => {
  const options = isEdit ? [
    { label: '计划中', value: 1 },
    { label: '沟通中', value: 2 },
    { label: '等位置', value: 3 },
  ] : [
    { label: '计划中', value: 1 },
    { label: '沟通中', value: 2 },
    { label: '等位置', value: 3 },
    { label: '已确定', value: 4 },
    { label: '已开业', value: 5 },
  ];

  return (
    <V2FormSelect
      disabled={disabled}
      name={name}
      label={label}
      options={options}
      rules={rules}
      required={required}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig
      }}
      formItemConfig={formConfig}
    />
  );
};

export default FormFollowingStatus;
